import { PRODUCTS } from '../constants';

export const hasAc = crewFinder => crewFinder.hasAc;

export const hasHalfBoard = crewFinder => crewFinder.orderItems.some(item => [
  PRODUCTS.HALF_BOARD_CLASSIC,
  PRODUCTS.HALF_BOARD_PREMIUM,
  PRODUCTS.HALF_BOARD_LUXURY,
  PRODUCTS.HALF_BOARD_LUXURY_PLUS,
].includes(item.productId));

export const hasHost = crewFinder => crewFinder.orderItems.some(item => item.productId === PRODUCTS.HOSTESS_ID);

export const hasSkipper = () => true;

export const availableExtras = ['Air Conditioning', 'Host', 'Half Board'];
